import React from 'react';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { TandemFreeIconTextProps } from '../IndeedModels';
import TandemFreeText from './TandemFreeText';

const TandemFreeIconText = ({ children, icon }: TandemFreeIconTextProps) => {
    return (
        <>
            {isMobile ? (
                <Grid container direction="row" spacing={1}>
                    <Grid item xs={2}>
                        {icon}
                    </Grid>
                    <Grid item xs={10}>
                        <TandemFreeText>{children}</TandemFreeText>
                    </Grid>
                </Grid>
            ) : (
                <Grid container direction="row" spacing={1}>
                    <Grid item>{icon}</Grid>
                    <Grid item>
                        <TandemFreeText>{children}</TandemFreeText>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default TandemFreeIconText;
